
import { Component, Vue, Prop } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/es'

@Component({
  components: {
    DatePicker
  }
})
export default class DateSelector extends Vue {
  @Prop({ required: true })
  value: any

  @Prop({ required: false, default: 'D [/] MMMM [/] YYYY' })
  format: any

  lang = {
    days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    pickers: ['Siguientes 7 días', 'Siguientes 30 días', '7 días anteriores', '30 días anteriores'],
    placeholder: {
      date: 'Seleccciona fecha',
      dateRange: 'Seleccciona rango'
    }
  }
}
